import { createElementFromTemplate } from '../../dom';
const TEMPLATE = `
    <div class="ag-cell-label-container"
         role="presentation">
        <div class="ag-header-cell-label"
             role="presentation"
             unselectable="on">
            <span class="ag-header-cell-text"
                  role="columnheader"
                  unselectable="on"></span>
        </div>
    </div>`;
export class AgHeaderBaseComponent {
    constructor() {
        this.textSelector = 'span.ag-header-cell-text';
        this.eGui = createElementFromTemplate(TEMPLATE)[0];
    }
    init(params) {
        this.setupText(params.displayName);
    }
    getGui() {
        return this.eGui;
    }
    refresh() {
        return true;
    }
    setupText(displayName) {
        const eText = this.eGui.querySelector(this.textSelector);
        if (Boolean(eText)) {
            eText.innerHTML = displayName;
        }
    }
}
